{
  "INTEGRATION_APPS": {
    "FETCHING": "Notiek Integrāciju Iegūšana",
    "NO_HOOK_CONFIGURED": "Šajā kontā nav nokonfigurēta neviena {integrationId} integrācija.",
    "HEADER": "Lietojumprogrammas",
    "STATUS": {
      "ENABLED": "Iespējots",
      "DISABLED": "Atspējots"
    },
    "CONFIGURE": "Konfigurēt",
    "ADD_BUTTON": "Pievienojiet jaunu hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Apstiprināt dzēšanu",
        "ACCOUNT": "Atvienot"
      },
      "MESSAGE": {
        "INBOX": "Vai tiešām vēlaties izdzēst?",
        "ACCOUNT": "Vai tiešām vēlaties atvienot?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Jā, Dzēst",
        "ACCOUNT": "Jā, Atvienot"
      },
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Hook ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "LIST": {
      "FETCHING": "Notiek integrāciju hook iegūšana",
      "INBOX": "Iesūtne",
      "EDIT": {
        "BUTTON_TEXT": "Rediģēt"
      },
      "DELETE": {
        "BUTTON_TEXT": "Dzēst"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Izvēlieties Iesūtni",
          "PLACEHOLDER": "Izvēlieties Iesūtni"
        },
        "SUBMIT": "Izveidot",
        "CANCEL": "Atcelt"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrācijas hook ir veiksmīgi pievienots",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "EDIT": {
      "TITLE": "Rediģēt {name}",
      "FORM": {
        "SUBMIT": "Atjaunināt",
        "CANCEL": "Atcelt"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrācijas hook ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Savienoties"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Atvienot"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow ir dabiskas valodas apstrādes platforma, sarunvalodas interfeisa veidošanai. Integrējot to ar {installationName}, roboti vispirms apstrādās vaicājumus un vajadzības gadījumā pārsūtīs tos aģentiem. Tas palīdz kvalificēt potenciālos klientus un samazināt aģentu darba slodzi, atbildot uz bieži uzdotajiem jautājimiem. Lai pievienotu Dialogflow, pakalpojumā Google Console izveidojiet Service Account un kopīgojiet akreditācijas datus. Sīkāku informāciju skatiet dokumentācijā",
      "DAKTELA": "Sinhronizējiet e-pastus un tiešsaistes tērzēšanas ar savu daktela kontu.",
      "RETINO": "Retino ienes kārtību atgriešanas un pretenziju pārvaldībā.",
      "MAILSHIP": "Mailship ir noliktavas un pasūtījumu izpildes pārvaldības sistēma. Skatiet pasūtījuma statusu, izsekošanu un ekspedīcijas informāciju.",
      "RAYNET": "Pievienojiet savu Raynet CRM kontu, lai piekļūtu klientu datiem. Pievienojiet savienojumu ar savu Raynet lietotājvārdu un API marķieri."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Pārbaudīt savienojumu",
      "SUCCESS": "Savienojums veiksmīgs",
      "ERROR": "Savienojums neizdevās. Lūdzu, pārbaudiet savus pieteikšanās datus."
    }
  }
}
